module.exports = __webpack_public_path__ + "static/swiftlane_system-35f8b4d7adf99f148095f369058668a9.png";